// extracted by mini-css-extract-plugin
export default {"PatientInfoPop":"PatientInfoPop_PatientInfoPop__ntsjY","header":"PatientInfoPop_header__KxK5W"};